import React from 'react';
import { Reveal } from './Reveal';
import { ArrowRight } from 'lucide-react';
export const TrackProgressSection = () => {
  return <section className="py-12 md:py-16 px-[5vw] bg-white overflow-hidden" data-id="element-401">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-402">
        {/* Left: Visual Mockup */}
        <Reveal data-id="element-403">
          <div className="relative flex justify-center lg:justify-end pr-0 lg:pr-10" data-id="element-404">
            {/* Phone Mockup */}
            <div className="w-[260px] bg-bg rounded-[40px] p-5 shadow-[0_32px_80px_rgba(0,0,0,0.12)] border-[6px] border-white relative z-10" data-id="element-405">
              <div className="mb-6" data-id="element-406">
                <p className="text-[10px] font-bold text-ink-soft tracking-wider mb-1" data-id="element-407">
                  FATURAMENTO DO MÊS
                </p>
                <div className="font-serif font-bold text-[34px] text-gold leading-none mb-1" data-id="element-408">
                  R$ 7.540
                </div>
                <p className="text-xs text-ink-soft" data-id="element-409">
                  Abril 2026 · Lucro: R$ 4.373
                </p>
              </div>

              {/* CSS Bar Chart — organic growth with some dips */}
              <div className="flex items-end justify-between gap-1.5 mt-8 border-b border-line pb-2" style={{
              height: '160px'
            }} data-id="element-410">
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-411">
                  <div className="w-full rounded-t-md" style={{
                  height: '48px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.5
                }} data-id="element-412"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-413">Jan</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-414">
                  <div className="w-full rounded-t-md" style={{
                  height: '67px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.55
                }} data-id="element-415"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-416">Fev</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-417">
                  <div className="w-full rounded-t-md" style={{
                  height: '58px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.5
                }} data-id="element-418"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-419">Mar</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-420">
                  <div className="w-full rounded-t-md" style={{
                  height: '82px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.6
                }} data-id="element-421"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-422">Abr</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-423">
                  <div className="w-full rounded-t-md" style={{
                  height: '72px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.55
                }} data-id="element-424"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-425">Mai</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-426">
                  <div className="w-full rounded-t-md" style={{
                  height: '105px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.7
                }} data-id="element-427"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-428">Jun</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-429">
                  <div className="w-full rounded-t-md" style={{
                  height: '95px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.65
                }} data-id="element-430"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-431">Jul</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-432">
                  <div className="w-full rounded-t-md" style={{
                  height: '120px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.8
                }} data-id="element-433"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-434">Ago</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-435">
                  <div className="w-full rounded-t-md relative" style={{
                  height: '140px',
                  backgroundColor: 'var(--rose)'
                }} data-id="element-436">
                    <div className="absolute -top-5 left-1/2 -translate-x-1/2 text-[10px] font-bold text-rose whitespace-nowrap" data-id="element-437">
                      Set*
                    </div>
                  </div>
                  <span className="text-[9px] font-bold text-rose" data-id="element-438">Set</span>
                </div>
              </div>
            </div>

            {/* Floating Chip */}
            <div className="absolute -bottom-6 -right-4 lg:-right-12 bg-white rounded-2xl p-4 shadow-[0_8px_32px_rgba(0,0,0,0.12)] z-20 animate-[float_6s_ease-in-out_infinite]" data-id="element-439">
              <p className="text-sm font-medium text-ink mb-1" data-id="element-440">
                Margem média 58%
              </p>
              <div className="inline-flex items-center gap-1 bg-green-soft text-[#059669] px-2 py-0.5 rounded text-xs font-bold" data-id="element-441">
                ↑ +4% vs mês anterior
              </div>
            </div>
          </div>
        </Reveal>

        {/* Right: Text */}
        <Reveal delay={0.2} data-id="element-442">
          <div data-id="element-443">
            <span className="text-xs font-bold tracking-widest text-ink-soft uppercase mb-4 block" data-id="element-444">
              O CHOQUE QUE TODA ARTESÃ TEM
            </span>
            <h2 className="font-serif font-bold text-[26px] md:text-[clamp(34px,4vw,48px)] tracking-[-0.02em] text-ink mb-6 leading-tight" data-id="element-445">
              Quanto você está deixando de ganhar agora?
            </h2>
            <p className="text-[15px] md:text-[17px] leading-[1.6] text-ink-soft mb-8" data-id="element-446">
              Toda artesã que começa a usar o Aurora passa pela mesma
              descoberta: "eu tava perdendo dinheiro nesse produto". Não é
              mágica. É só finalmente ver o número que sempre esteve ali —
              escondido no caderno, no Excel da sobrinha, na cabeça.
            </p>
            <a href="#preco" className="inline-flex items-center gap-3 bg-rose text-white px-8 py-3.5 rounded-full hover:bg-rose-deep transition-colors font-medium no-underline" data-id="element-447">
              Quero descobrir o meu número
              <ArrowRight size={18} data-id="element-448" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
};